export default __webpack_public_path__ + "static/media/5_icnea.a58b64ff.svg";